// Category Slider section Sachin
$(document).ready(function(){
  $('.cstm-collection-list').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    dots: false,
    arrows: true,
    prevArrow: $('.prev-btn-category'),
    nextArrow: $('.next-btn-category'),
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          autoplay: false,
          arrows: false
        }
      }
    ]
  });
});

// for shop the look
  $(document).ready(function() {
    var slider = $('.shop_pro_slider_wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-next look_right"></button>',
      nextArrow: '<button type="button" class="slick-prev look_left"></button>',
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });


    $('.prod_link_1').click(function() {
      slider.slick('slickGoTo', 0);
    });

    $('.prod_link_2').click(function() {
      slider.slick('slickGoTo', 1);
    });

    $('.prod_link_3').click(function() {
      slider.slick('slickGoTo', 2);
    });
  });


// for PDP header


const PDP_drawer = document.querySelector('#Details-menu-drawer-container');
const PDP_logo = document.querySelector(' .product .header__heading-logo-wrapper');
let isVisible = false; 
if (PDP_drawer && PDP_logo) {
  PDP_drawer.addEventListener('click', function() {
    isVisible = !isVisible;
    PDP_logo.style.opacity = isVisible ? '1' : '0';
  });
}



// infinite scroll collection page
document.addEventListener("DOMContentLoaded", function () {
  var pagEl = document.querySelector('#Huratips-Pagination');
  if (typeof Ajaxinate !== 'undefined' && pagEl && !window.__utAjaxinateInit) {
    window.__utAjaxinateInit = true;
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#Huratips-Pagination',
      loadingText: '<img src="https://cdn.shopify.com/s/files/1/0940/4232/5301/files/loading-loading-gif.gif?v=1752758104" width="100px" height="100px"/>',
      callback: function () {
        setTimeout(() => {
          applySavedGridLayout();
          enableScroll();
          removeDuplicateProducts();
        }, 50);
      }
    });
  }

  updateGridForMobile();
  applySavedGridLayout();
  observeProductGridReload();
  observeFilterChanges();
  handleFilterRemoval();

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".filter-btn");
    if (btn) {
      const selectedCols = btn.getAttribute("data-cols");
      const previousCols = sessionStorage.getItem("activeGridCols");
      const isFilterActive = checkIfFiltersActive();

      if (selectedCols === "1" && isFilterActive) return;

      sessionStorage.setItem("activeGridCols", selectedCols);

      if ((previousCols === "2" || previousCols === "3") && selectedCols === "1") {
        location.reload();
      } else {
        applySavedGridLayout();
        removeDuplicateProducts();
      }
      enableScroll();
    }
  });

  window.addEventListener("resize", () => {
    updateGridForMobile();
    applySavedGridLayout();
    enableScroll();
  });

  window.addEventListener("popstate", () => {
    const isFilterActive = checkIfFiltersActive();
    if (!isFilterActive) {
      sessionStorage.setItem("activeGridCols", "1");
      location.reload();
    } else {
      setTimeout(() => {
        applySavedGridLayout();
        enableScroll();
        removeDuplicateProducts();
      }, 100);
    }
  });
});

document.addEventListener("shopify:section:load", () => {
  applySavedGridLayout();
  enableScroll();
  removeDuplicateProducts();
});

function applySavedGridLayout() {
  let savedCols = sessionStorage.getItem("activeGridCols") || "1";
  const isFilterActive = checkIfFiltersActive();

  if (isFilterActive && savedCols === "1") {
    savedCols = "2";
    sessionStorage.setItem("activeGridCols", savedCols);
  }

  const isCollectionLinen = document.body.classList.contains("collectionLinen");
  const productGrid = document.querySelector(".cstm-collection-product-grid");
  const buttons = document.querySelectorAll(".filter-btn");
  const customComponents = document.querySelectorAll(".cstm-featured-slider, .cstm-banner-wrapper");
  const banner = document.querySelector(".vacation_banner_main");

  if (productGrid) {
    productGrid.classList.remove("grid-cols-1", "grid-cols-2", "grid-cols-3");

    if (savedCols === "1" && !isFilterActive) {
      productGrid.style.display = isCollectionLinen ? "none" : "grid";
      customComponents.forEach((el) => el.style.display = isCollectionLinen ? "block" : "none");
      if (!isCollectionLinen) productGrid.classList.add("grid-cols-1");

      const pagination = document.querySelector("#Huratips-Pagination");
      if (pagination) pagination.style.display = "none";
    } else {
      productGrid.style.display = "grid";
      productGrid.classList.add(`grid-cols-${savedCols}`);
      customComponents.forEach((el) => el.style.display = "none");

      const pagination = document.querySelector("#Huratips-Pagination");
      if (pagination) pagination.style.display = "block";
    }
  }

  buttons.forEach(btn => {
    btn.classList.toggle("active", btn.getAttribute("data-cols") === savedCols);
  });

  if (document.body.classList.contains("collectionvacation") && banner) {
    banner.classList.toggle("hide_banner", savedCols !== "1");
  }

  const pageWidthElements = document.querySelectorAll(".collectionLinen .cstm-width-featured");
  pageWidthElements.forEach(el => {
    if (window.innerWidth <= 767) {
      el.style.padding = "0 3%";
    } else {
      el.style.padding = savedCols === "1" ? "0 4%" : "0 9%";
    }
  });
  if (productGrid) {
    const allMobileGrids = document.querySelectorAll(".cstm-mobile-grid");
    const allVariantBlocks = document.querySelectorAll(".card_product_variants");
    const shouldHide = window.innerWidth <= 767 && productGrid.classList.contains("grid-cols-3");

    allMobileGrids.forEach(el => el.style.display = shouldHide ? "none" : "");
    allVariantBlocks.forEach(el => el.style.display = shouldHide ? "none" : "");
  }
}

function checkIfFiltersActive() {
  const urlParams = new URLSearchParams(window.location.search);
  for (const [key] of urlParams) {
    if (key.startsWith('filter.')) return true;
  }
  return false;
}

function updateGridForMobile() {
  const currentCols = sessionStorage.getItem("activeGridCols");
  if (window.innerWidth <= 767 && currentCols === "3") {
    sessionStorage.setItem("activeGridCols", "2");
  }
}

function enableScroll() {
  document.body.style.overflow = "auto";
  document.documentElement.style.overflow = "auto";
}

function removeDuplicateProducts() {
  const seen = new Set();
  document.querySelectorAll(".cstm-collection-product-grid .grid__item").forEach(item => {
    const handle = item.getAttribute("data-product-handle") || item.id || item.innerHTML;
    if (seen.has(handle)) {
      item.remove();
    } else {
      seen.add(handle);
    }
  });
}

function observeProductGridReload() {
  const container = document.querySelector(".cstm-collection-product-grid")?.parentElement;
  if (!container) return;

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const gridReloaded = [...mutation.addedNodes].some(
          node => node.nodeType === 1 && node.matches(".cstm-collection-product-grid")
        );
        if (gridReloaded) {
          setTimeout(() => {
            applySavedGridLayout();
            enableScroll();
            removeDuplicateProducts();
          }, 50);
        }
      }
    }
  });

  observer.observe(container, { childList: true, subtree: true });
}

function observeFilterChanges() {
  let currentUrl = window.location.href;
  setInterval(() => {
    if (window.location.href !== currentUrl) {
      currentUrl = window.location.href;
      setTimeout(() => {
        applySavedGridLayout();
        enableScroll();
        removeDuplicateProducts();
      }, 200);
    }
  }, 500);
}

function handleFilterRemoval() {
  document.addEventListener("click", (e) => {
    const isFilterRemoval = e.target.closest(
      '.facet-remove, .active-facets__button, .filter-remove, ' +
      '[data-filter-clear], .facet__remove, .clear-filters, ' +
      '.active-facets__button-remove, [aria-label*="Remove"]'
    );

    if (isFilterRemoval) {
      sessionStorage.setItem("activeGridCols", "1");
      setTimeout(() => {
        applySavedGridLayout();
        removeDuplicateProducts();
        enableScroll();
      }, 200);
    }
  });
}
